export enum SkipTraceMode {
  INSTANT = "INSTANT",
  DELAYED = "DELAYED",
}
